<app-topbar></app-topbar>
<div class="content-container">
  <app-navbar></app-navbar>
  <div class="container-fluid">
    <h2 class="my-3">Códigos Gestos</h2>

    <div class="row">
      <!-- Estados Civiles -->
      <div class="col-12 col-lg-6 mb-4">
        <div class="card h-100">
          <div
            class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
          >
            <h4 class="mb-0">Estados Civiles</h4>
            <button
              class="btn btn-light btn-sm"
              (click)="guardarCodigosEstadosCiviles()"
            >
              Guardar Estados Civiles
            </button>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table
                id="tablaEstadosCiviles"
                class="table table-striped table-bordered"
              >
                <thead>
                  <tr>
                    <th>ID</th>
                    <th class="columna-codigo">Código Gestos</th>
                    <th class="columna-descripcion">Descripción</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Parentescos -->
      <div class="col-12 col-lg-6 mb-4">
        <div class="card h-100">
          <div
            class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
          >
            <h4 class="mb-0">Parentescos</h4>
            <button
              class="btn btn-light btn-sm"
              (click)="guardarCodigosParentescos()"
            >
              Guardar Parentescos
            </button>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table
                id="tablaParentescos"
                class="table table-striped table-bordered"
              >
                <thead>
                  <tr>
                    <th>ID</th>
                    <th class="columna-codigo">Código Gestos</th>
                    <th class="columna-descripcion">Descripción</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
